import type { Suggestion, User } from '../types';

export function countPendingSubscriptionApprovals(users: readonly User[]): number {
    return users.filter(
        (u) => u.subscription && u.subscription.adminViewed === false && u.role !== 'superuser',
    ).length;
}

export function countNewSuggestions(suggestions: readonly Suggestion[]): number {
    return suggestions.filter((s) => (s.status || 'new') === 'new').length;
}

export function formatAdminBadgeCount(count: number): string | null {
    if (count <= 0) return null;
    if (count > 100) return '100+';
    return String(count);
}
